import L from 'leaflet';
import PlaceType from './PlaceType';
import Photo from './Photo';
import VideoLink from './VideoLink';
import { DataOrigin } from './types';

export default class Place {

  public photos: Photo[];
  public videos: VideoLink[];

  public markerLat: Number;
  public markerLon: Number;

  public link: string;

  private placeAddedToStore = false;
  private markerIcon: L.Icon = null;
  public markerAction: string;
  public wayPointsPolylines: L.Polyline[];

  public getMarker() {
    return window.leaflet.markers[this.from_type][this.id];
  }

  constructor(public id: number, public name: string, public description: string, public lat: number, public lon: number, public type: PlaceType, public approved: boolean, public waypoints: [], public from_type: DataOrigin, public is_active: boolean) {
    this.photos = [];
    this.videos = [];
    this.markerLat = lat;
    this.markerLon = lon;
  }

  public createWayPointsPolylines() {
    this.wayPointsPolylines = [];
    for(const segment of this.waypoints) {
      const poliline = new L.Polyline(segment, {
        color: 'red',
        weight: 5,
        opacity: 1,
        smoothFactor: 1,
      });
      this.wayPointsPolylines.push(poliline);
    }
  }

  public addWayPointsPolylinesToMap() {
    for(const poliline of this.wayPointsPolylines) {
      poliline.addTo(window.mainmap);
      poliline.bringToFront();
      this.getMarker().bringToFront();
    }
  }

  public removeWayPointsPolylinesFromMap() {
    for(const poliline of this.wayPointsPolylines) {
      poliline.removeFrom(window.mainmap);
    }
  }

  public createMarker() {
    const draggable = Boolean(this.from_type == DataOrigin.maplas && window.window.isDesktop && window.$store.state.user);
    let marker = null;
    if ((this.type) && (this.type.icon instanceof Object)) {
      marker = new L.CircleMarker([this.lat, this.lon], {radius: 16, color: this.type.icon.color});
    } else {
      const markerIconClass = this.getMarkerIconClass();
      this.markerIcon = this.getMarkerIcon(markerIconClass);
      marker = new L.Marker([this.lat, this.lon], {icon: this.markerIcon, draggable: draggable, contextmenu: false, contextmenuItems: []});
    }
    marker.on("click", (event) => {
      if (! this.placeAddedToStore) {
        window.$store.state.maplasPlaces[this.from_type].push(this);
        this.placeAddedToStore = true;
        this.markerAction = 'click';
      }
      this.markerLat = marker.getLatLng().lat;
      this.markerLon = marker.getLatLng().lng;
      L.DomEvent.stopPropagation(event);
    });
    if ((this.waypoints) && (this.waypoints.length > 0)) {
      marker.on("mouseover", (event) => {
        if (! this.placeAddedToStore) {
          this.createWayPointsPolylines();
          window.$store.state.maplasPlaces[this.from_type].push(this);
          this.placeAddedToStore = true;
        }
        if (this.wayPointsPolylines) {
          this.addWayPointsPolylinesToMap();
        }
      });
      marker.on("mouseout", (event) => {
        if (this.wayPointsPolylines) {
          this.removeWayPointsPolylinesFromMap();
        }
      });
    }
    window.leaflet.markers[this.from_type][this.id] = marker;
  }

  public convertToApiPlaceSave() {
    return {id: this.id, name: this.name, description: this.description, lat: this.lat, lon: this.lon, type: this.type.id};
  }

  public setDraggable(drag: boolean) {
    const marker = this.getMarker();
    if (marker instanceof L.Marker) {
      marker.options.draggable = drag;
    }
  }

  public addPhoto(photo: Photo) {
    this.photos.push(photo);
  }

  public addVideo(video: VideoLink) {
    this.videos.push(video);
  }

  public getMarkerIconClass() {
    if (this.type) {
      if (this.type.icon) {
        if (this.type.icon instanceof Object) {
          return 'maplas_other';
        } else {
          return this.type.icon.replaceAll('-', '_');
        }
      } else {
        return 'maplas_other';
      }
    } else {
      return 'maplas_other';
    }
  }

  public updateMarkerIcon() {
    const marker = this.getMarker();
    if (marker instanceof L.Marker) {
      // MarkersCanvas renders markers directly from marker.options.icon. Calling
      // Leaflet's setIcon() also creates a DOM icon, which duplicates the canvas
      // marker. Replace the option and invalidate the canvas image cache instead.
      marker.options.icon = this.getMarkerIcon(this.getMarkerIconClass());
      // Clean up any DOM icon left by an earlier setIcon() call.
      // @ts-ignore MarkersCanvas markers normally have no DOM icon.
      if (marker._icon && marker._icon.parentNode) {
        // @ts-ignore Remove the stale Leaflet DOM icon if one was created.
        marker._icon.parentNode.removeChild(marker._icon);
        // @ts-ignore Clear Leaflet's reference so it cannot be reused.
        marker._icon = null;
      }
      // @ts-ignore MarkersCanvas attaches the loaded bitmap to its marker objects.
      marker.image = null;
      window.markersCanvas.redraw();
    }
  }

  private getMarkerIcon(markerIconClass: string): L.Icon {
    return window.markerLIcons[markerIconClass] || window.markerLIcons.maplas_other;
  }
}
